import AdminConfigTractorHistory from './AdminConfigTractorHistory';
export default AdminConfigTractorHistory;
